// Module
var code = "<i class=\"market-segment-icon {{getMarketSegment().iconClass}}\" ng-class=\"{'no-icon-margins':!showLabel}\" title=\"{{getMarketSegment().label | translate}}\"> {{(showLabel ? getMarketSegment().label : '') | translate}} </i> ";
// Exports
module.exports = code;